export default "__VITE_ASSET__a4258085__"